import { SECONDARY_API_CLIENT } from 'services/API';

import { ENDPOINTS } from './ResumeSearch.constants';

export const searchResumes = async filtersPayload => {
  return SECONDARY_API_CLIENT.post(ENDPOINTS.Resumes, filtersPayload);
};
